import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {SwedenResponsibleGamingButtonsBox} from "./boxes/sweden.responsible-gaming-buttons.box";
import {SwedenSelfExclusionButtonComponent} from "./self-exclusion-button/sweden.self-exclusion-button.component";
import {SwedenGamingLimitsButtonComponent} from "./gaming-limits/sweden.gaming-limits-button.component";
import {SwedenSelfTestButtonComponent} from "./self-test-button/sweden.self-test-button.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../basic-components/blank-separator/blank-horizontal-separator.box";

interface SwedenResponsibleGamingButtonsComponentProps {
    useIconsOnly: boolean;
    isShownInHeader?: boolean;
}
export const SwedenResponsibleGamingButtonsComponent = observer(
    class SwedenResponsibleGamingButtonsComponent extends OrbitComponent<SwedenResponsibleGamingButtonsComponentProps> {
        render() {
            let spaceMultiplier;
            if(this.props.useIconsOnly) {
                spaceMultiplier = 2;
            } else if(this.props.isShownInHeader){
                spaceMultiplier = 0.5;
            } else {
                spaceMultiplier = 1;
            }


            const isShownInHeader = this.props.isShownInHeader ?? false;

            return (
                <SwedenResponsibleGamingButtonsBox>
                    <SwedenSelfExclusionButtonComponent useIconsOnly={this.props.useIconsOnly} isShownInHeader={isShownInHeader}/>
                    <BlankHorizontalSeparatorBox multiplier={spaceMultiplier}/>
                    <SwedenGamingLimitsButtonComponent useIconsOnly={this.props.useIconsOnly} isShownInHeader={isShownInHeader}/>
                    <BlankHorizontalSeparatorBox multiplier={spaceMultiplier}/>
                    <SwedenSelfTestButtonComponent useIconsOnly={this.props.useIconsOnly} isShownInHeader={isShownInHeader}/>
                </SwedenResponsibleGamingButtonsBox>
            );
        }
    }
);